import api from './api'

export async function getProducts(params = {}) {
  const { data } = await api.get('/products', { params })
  return data
}

export async function getProduct(slug) {
  const { data } = await api.get(`/products/${encodeURIComponent(slug)}`)
  return data
}

export async function getCategories() {
  const { data } = await api.get('/categories')
  return data
}
